import { useCallback } from 'react';

import { toast } from 'sonner';

import { useUpdateActivity as useUpdateActivityMutation } from '@queries';

type CreateActivityFlowOptions = {
    activityId: number;
    selectedClub: number;
};

const ERROR_MESSAGE = 'Failed to update activity';

/**
 * Updates the current activity with the selected club.
 *
 * Used when the user chooses to update the current activity.
 */
export const useUpdateActivity = ({ selectedClub, activityId }: CreateActivityFlowOptions) => {
    const { mutateAsync: updateActivityClub, isPending: mutatingActivityClub } = useUpdateActivityMutation({
        onError: (error) => {
            console.error('failed to update club', error);
            toast.error(ERROR_MESSAGE);
        },
    });

    const handleUpdateCurrentActivity = useCallback(async () => {
        await updateActivityClub({ activityId, clubId: selectedClub });
    }, [activityId, selectedClub, updateActivityClub]);
    return {
        handleUpdateCurrentActivity,
        isPending: mutatingActivityClub,
    };
};
